/**
 * List of availables languages for HERE maps controls
 * Put English at first position as it is used as a fallback
 *
 *  @type {[string]}
 */
const AVAILABLE_UI_LANGUAGES = [
  'en-US', // – English (United States)

  'de-DE', // – German
  'es-ES', // – Spanish
  'fi-FI', // – Finnish
  'fr-FR', // – French
  'it-IT', // – Italian
  'nl-NL', // – Dutch
  'pl-PL', // – Polish
  'pt-BR', // – Portuguese (Brazil)
  'pt-PT', // – Portuguese (Portugal)
  'ru-RU', // – Russian
  'tr-TR', // – Turkish
  'zh-CN' // – Chinese (China)
]

/**
 * List of availables languages for HERE maps controls
 * Put English at first position as it is used as a fallback
 *
 * @type {{string: string}}
 */
const LANG_TO_TILE_LANG_MAPPING = {
  en: 'eng', // – English

  ar: 'ara', // – Arabic
  eu: 'baq', // – Basque
  ca: 'cat', // – Catalan
  zh_CN: 'chi', // – Chinese (simplified)
  zh: 'chi', // – Chinese (simplified)
  zh_TW: 'cht', // – Chinese (traditional)
  cs: 'cze', // – Czech
  da: 'dan', // – Danish
  nl: 'dut', // – Dutch
  fi: 'fin', // – Finnish
  fr: 'fre', // – French
  de: 'ger', // – German
  gd: 'gle', // – Gaelic
  el: 'gre', // – Greek
  he: 'heb', // – Hebrew
  hi: 'hin', // – Hindi
  id: 'ind', // – Indonesian
  it: 'ita', // – Italian
  no: 'nor', // – Norwegian (inclusive) - both Norwegian Bokmål and Norwegian Nynorsk
  nb: 'nor', // – Norwegian Bokmål
  nn: 'nor', // – Norwegian Nynorsk
  fa: 'per', // – Persian
  pl: 'pol', // – Polish
  pt: 'por', // – Portuguese
  ru: 'rus', // – Russian
  si: 'sin', // – Sinhalese
  es: 'spa', // – Spanish
  sv: 'swe', // – Swedish
  th: 'tha', // – Thai
  tr: 'tur', // – Turkish
  uk: 'ukr', // – Ukrainian
  ur: 'urd', // – Urdu
  vi: 'vie', // – Vietnamese
  cy: 'wel'  // – Welsh
}

export function mapLangToAvailableLangForUiControls (lang) {
  if (AVAILABLE_UI_LANGUAGES.includes(lang)) {
    return lang
  }

  if (AVAILABLE_UI_LANGUAGES.includes(lang.replace('_', '-'))) {
    return lang.replace('_', '-')
  }

  return Object.keys(AVAILABLE_UI_LANGUAGES).find(key => {
    if (key.substring(0, 2) === lang.substring(0, 2)) {
      return key
    }
    return null
  }) || AVAILABLE_UI_LANGUAGES[0]    // default is the first one, which is English
}

export function mapLangToAvailableLangForTiles (lang) {
  return LANG_TO_TILE_LANG_MAPPING[lang] ||
    LANG_TO_TILE_LANG_MAPPING[lang.substring(0, 2)] ||
    LANG_TO_TILE_LANG_MAPPING['enEN']  // default is the first one, which is English
}



// WEBPACK FOOTER //
// ./src/components/Leaflet/Languages.js